<oe-flat-widget [title]="'GENERAL.CUR_YEAR_PRODUCTION' | translate" [icon]="{name: 'oe-production', color: 'production'}">
  <ng-container>
    <p class="signage-font-edge5card">{{getYearProduction()}}</p>
  </ng-container>
</oe-flat-widget>
